<template>
  <v-card :class="(isLifetime)? 'special-border-color pa-1 mx-0' : 'pa-1 mx-0'"
          outlined style="width: 100%; background-color: rgba(0,0,0,0)">
    <v-container class="mx-0" fluid>
      <v-row>
        <div class="d-flex align-center justify-center text-center ma-0" style="width: 100%;">
          <h2>{{ plan.planName }}
            <v-chip v-if="isLifetime" class="ml-1" color="secondary" small>Popular
              <v-icon class="ml-2" color="accent" dense small>fa-star</v-icon>
            </v-chip>
            <v-chip v-else-if="plan.planName.includes('Anual')  || plan.planName.includes('Annually')" class="ml-1"
                    color="accent" small text-color="secondary">{{ $t('savePrefix') }} <b class="ml-1">42 USD</b>
            </v-chip>
          </h2>
        </div>
      </v-row>
      <v-row>
        <p class="text-center mt-1 mb-3" style="width: 100% !important;">{{ plan.price }} {{ plan.currency }}
          {{ plan.periodicity }} | {{ plan.billed }}</p>
      </v-row>
      <v-row class="mb-n3" align="center" justify="center">
        <!-- <v-btn v-if="isLifetime" class="swiset-button text-center mb-3" style="width: 95%" @click="payLifetime">
          {{ getButtonText() }}
          <v-icon class="ml-2" color="black" right small>fa-shopping-cart</v-icon>
        </v-btn> -->
        <div class="paypal-button-container"></div>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "PlanCard",
  props: {
    plan: Object,
  },
  data() {
    return {
      overlayPay: false,
      isLifetime: false,
    };
  },
  mounted() {
    this.verifyLifetime();
  },
  methods: {
    verifyLifetime() {
      this.isLifetime = this.plan.planName.includes('Lifetime') || this.plan.planName.includes('Lifetime');
    },
    payLifetime() {
      window.open('https://api.whatsapp.com/send?phone=573195238986&text=Hola%20Swiset,%20quiero%20pagar%20el%20lifetime');
    },
  }
}
</script>

<i18n>
{
  "en": {
    "btnCTA": "Buy Now",
    "savePrefix": "Save"
  },
  "es": {
    "btnCTA": "Comprar",
    "savePrefix": "Ahorra"
  }
}
</i18n>

<style scoped>
.special-border-color {
  border: 2px solid #111111 !important;
}
</style>
